import React, { useEffect, useRef, useState } from "react"
import "../index.scss"

import Layout from "src/components/layout"
import Head from "src/components/Head"

import SportObjectsSearch from "src/components/clients/SportObjectsSearch/SportObjectsSearch"
import Faq from "src/components/clients/Faq/Faq"
import Start from "src/components/Start/Start"

import { useTranslation } from "react-i18next"
import { graphql, useStaticQuery } from "gatsby"
import COUNTRY from "../../constants"
import BRANDS from "../../brands"

const questions = [
  {
    question: "objects.questions.question-1.question",
    answer: "objects.questions.question-1.answer",
  },
  {
    question: "objects.questions.question-2.question",
    answer: "objects.questions.question-2.answer",
  },
  {
    question: "objects.questions.question-3.question",
    answer: "objects.questions.question-3.answer",
  },
  {
    question: "objects.questions.question-4.question",
    answer: "objects.questions.question-4.answer",
  },
]

const ClientsMain = ({ location }) => {
  const data = useStaticQuery(graphql`
    query objectPageClientsEnAm {
      site {
        siteMetadata {
          senderPath
          countries {
            am {
              hotLine {
                tel
                title
              }
            }
          }
        }
      }
    }
  `)

  const { t, i18n } = useTranslation()

  const country = COUNTRY.en_am

  useEffect(() => {
    i18n.changeLanguage(country)
  }, [i18n])

  const [email, setEmail] = useState("")
  const emailDisabled = false
  const [, setForm] = useState({
    company: "",
  })
  const sendForm = (form) => {
    setForm(form)
    return fetch(data.site.siteMetadata.senderPath, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(form),
    })
      .then((response) => {
        alert(t("sendFormAlert"))
      })
      .catch((e) => {
        console.error(e)
      })
  }
  const startRef = useRef()

  return (
    <div className="objects-page">
      <Head
        lang={country}
        title={t("head.objects.title", { brand: BRANDS.ALLSPORTS.brand })}
        description={t("head.objects.description", {
          brand: BRANDS.ALLSPORTS.brand,
        })}
        slug="/objects/"
      />
      <Layout
        hotLine={data.site.siteMetadata.countries.am.hotLine}
        location={location}
        country={country}
      >
        <SportObjectsSearch
          location={location}
          titleLt={t("objects.mapTitle")}
          country={COUNTRY.AM}
        />
        <Faq
          country={COUNTRY.AM}
          questions={questions}
          hotLine={data.site.siteMetadata.countries.am.hotLine}
        />
        <Start
          type="clients"
          startRef={startRef}
          email={email}
          emailDisabled={emailDisabled}
          setEmail={setEmail}
          setForm={sendForm}
        />
      </Layout>
    </div>
  )
}

export default ClientsMain
